
import { Link, NavLink } from "react-router-dom";
import auth from "../shared/auth";
import QuestionMarkIcon from "../films/icons/question-mark";
import LightbulbIcon from "../films/icons/lightbulb";
import IconWithBadge from "../shared/icon-with-badge";
import UnauthenticatedMenu from "./unauthticated-menu";
import AdminMenu from "./admin-menu";
import UserMessages from "./user-messages";
import getConfig from "./config";

const TopMenu = (props) => {
  const {
    history,
    authenticated,
    userFilm,
    mobileMenu,
    setMobileMenu,
    handleGuideResetClick,
    handleHelpButtonClick,
    onDismissAllMessages,
    allMessages,
    onDismissMessage,
    onMessageLinkClick,
    burgerClick,
    onLogout,
    userName,
    userFirstName,
    userLastName,
    userEmailAddress,
    profileBackgroundColor
  } = props;

  const menuItemClick = (event) => {
    event.currentTarget.blur();
    setMobileMenu(false);
  };

  const { beta: isBeta } = getConfig() as any;

  return (
    <nav
      className="navbar is-fixed-top"
      role="navigation"
      aria-label="main navigation">
      <div className="navbar-brand">
        <NavLink to={"/films"} className="navbar-item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="184.16"
            height="42.483"
            viewBox="0 0 184.16 42.483">
            <defs>
              <radialGradient
                id="radial-gradient"
                cx="0.036"
                cy="0.973"
                r="1.258"
                gradientTransform="translate(-0.075) scale(1.15 1)"
                gradientUnits="objectBoundingBox">
                <stop offset="0.001" stopColor="#54eec5" />
                <stop offset="0.256" stopColor="#6bccd0" />
                <stop offset="0.996" stopColor="#ad6fef" />
              </radialGradient>
            </defs>
            <g
              id="Group_3786"
              data-name="Group 3786"
              transform="translate(-522.405 -272.658)">
              <path
                id="Path_32829"
                data-name="Path 32829"
                d="M587.292,272.658"
                fill="#fff"
              />
              <path
                id="Path_32830"
                data-name="Path 32830"
                d="M582.192,304.176m-14.335-13.058a1.882,1.882,0,0,1,2.146-2.04,7.477,7.477,0,0,1,1.6.18.267.267,0,0,0,.323-.2l.734-3.3a.264.264,0,0,0-.174-.309,10.761,10.761,0,0,0-3.433-.558c-3.8,0-6.472,1.97-6.472,6.05v1.337h-2.894a.53.53,0,0,0-.53.53v3.09a.53.53,0,0,0,.53.53h2.894v12.906a.531.531,0,0,0,.531.531h4.215a.53.53,0,0,0,.53-.531V296.429h4.113a.53.53,0,0,0,.53-.53v-3.09a.53.53,0,0,0-.53-.53h-4.113Zm7.7,18.748h4.215a.531.531,0,0,0,.53-.531V292.809a.53.53,0,0,0-.53-.53h-4.215a.53.53,0,0,0-.531.53v16.526A.531.531,0,0,0,575.561,309.866Zm9.058,0h4.215a.531.531,0,0,0,.531-.531V285.422a.531.531,0,0,0-.531-.53h-4.215a.53.53,0,0,0-.53.53v23.913A.53.53,0,0,0,584.619,309.866Zm9.016,0h4.215a.53.53,0,0,0,.53-.531v-9.7a2.857,2.857,0,0,1,2.814-3.165c1.548,0,2.674,1.09,2.674,3.1v9.775a.53.53,0,0,0,.53.531h4.216a.531.531,0,0,0,.53-.531v-9.7c0-1.934,1.125-3.13,2.778-3.13a2.676,2.676,0,0,1,2.744,2.989v10.377h5.276V298.505c0-4.292-2.251-6.578-6.085-6.578a6.276,6.276,0,0,0-5.487,2.638h-.317a4.543,4.543,0,0,0-4.5-2.638,5.748,5.748,0,0,0-4.854,2.392h-.317l-.41-1.833a.266.266,0,0,0-.259-.207h-4.076a.53.53,0,0,0-.531.53v16.526A.531.531,0,0,0,593.635,309.866Zm46.654-3.9c-.809,0-1.231-.422-1.231-1.3v-5.769c0-4.959-3.587-6.964-7.808-6.964-4.624,0-7.58,2.5-8.057,6.139a.266.266,0,0,0,.265.3h4.762a.269.269,0,0,0,.258-.213,2.539,2.539,0,0,1,2.772-2.073,2.237,2.237,0,0,1,2.532,2.391v.563l-5.557.6c-3.166.352-5.7,1.935-5.7,5.346,0,3.483,2.673,5.242,6.437,5.242,2.849,0,4.642-.915,5.768-2.428.739,1.618,2.146,2.076,3.8,2.076h1.915a.265.265,0,0,0,.265-.266v-3.639Zm-6.507-2.884c0,2.392-2.216,3.166-3.9,3.166-1.231,0-2.075-.422-2.075-1.513,0-1.055.984-1.583,2.251-1.723l3.728-.422Zm9.721,6.789h4.215a.531.531,0,0,0,.531-.531v-8.72c0-2.849,1.758-4.115,3.728-4.115,2.04,0,3.588,1.336,3.588,4.009v8.826a.53.53,0,0,0,.53.531h4.216a.53.53,0,0,0,.53-.531v-9.916c0-4.643-2.638-7.492-7.07-7.492a6.167,6.167,0,0,0-5.206,2.392h-.316l-.411-1.833a.265.265,0,0,0-.259-.207H643.5a.53.53,0,0,0-.53.53v16.526A.53.53,0,0,0,643.5,309.866Zm21.167,0h4.216a.531.531,0,0,0,.53-.531V292.809a.53.53,0,0,0-.53-.53H664.67a.53.53,0,0,0-.53.53v16.526A.53.53,0,0,0,664.67,309.866Zm7.7,0H686.75a.53.53,0,0,0,.53-.531v-2.984a.53.53,0,0,0-.53-.53h-7.595v-.247l7.637-10.518a.528.528,0,0,0,.1-.311v-1.936a.53.53,0,0,0-.53-.53H672.686a.53.53,0,0,0-.53.53v2.984a.53.53,0,0,0,.53.531h7v.246l-7.741,10.517a.532.532,0,0,0-.1.315v1.933A.531.531,0,0,0,672.369,309.866Zm29.166-5.839c-.422,1.336-1.653,2.04-3.447,2.04a3.794,3.794,0,0,1-4.08-3.553h12.381a10.115,10.115,0,0,0,.106-1.407c-.035-6.542-4.221-9.18-8.618-9.18-4.924,0-9.074,3.482-9.074,9.321,0,5.452,3.9,8.97,9.285,8.97,4.749,0,7.809-2.463,8.477-6.191Zm-3.658-7.949a3.35,3.35,0,0,1,3.588,2.954h-7.386A3.675,3.675,0,0,1,697.877,296.078Z"
                fill="#fff"
              />
              <rect
                id="Rectangle_4225"
                data-name="Rectangle 4225"
                width="5.276"
                height="5.276"
                rx="0.53"
                transform="translate(575.03 284.892)"
                fill="#fff"
              />
              <rect
                id="Rectangle_4226"
                data-name="Rectangle 4226"
                width="5.276"
                height="5.276"
                rx="0.53"
                transform="translate(664.14 284.892)"
                fill="#fff"
              />
              <path
                id="Path_32831"
                data-name="Path 32831"
                d="M546.484,290.524H524.526a2.121,2.121,0,0,1-2.121-2.121v-3.969a2.121,2.121,0,0,1,2.121-2.121h21.958a2.121,2.121,0,0,1,2.121,2.121V288.4A2.121,2.121,0,0,1,546.484,290.524Zm2.121,8.839v-3.969a2.121,2.121,0,0,0-2.121-2.121H534.118A2.121,2.121,0,0,0,532,295.394v3.969a2.121,2.121,0,0,0,2.121,2.121h12.366A2.121,2.121,0,0,0,548.6,299.363Zm-16.666,10.961v-3.969a2.12,2.12,0,0,0-2.121-2.121h-5.292a2.121,2.121,0,0,0-2.121,2.121v3.969a2.121,2.121,0,0,0,2.121,2.121h5.292A2.121,2.121,0,0,0,531.939,310.324Z"
                fill="url(#radial-gradient)"
              />
              <path
                id="Path_32832"
                data-name="Path 32832"
                d="M582.192,315.141"
                fill="#fff"
              />
            </g>
          </svg>
          {isBeta && <span className="tag is-purple is-beta">Beta</span>}
        </NavLink>

        <a
          role="button"
          className={
            "navbar-burger " + (mobileMenu ? " is-active" : "")
          }
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          onClick={burgerClick}>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div className="is-hidden-tablet mb-1 ml-1">This site is currently only optimised for desktop</div>
      {authenticated && (
        <div
          id="navbarBasicExample"
          className={"navbar-menu" + (mobileMenu ? " is-active" : "")}>
          <div className="navbar-start">
            <div className="navbar-item">
              <button
                className="button is-transparent"
                onClick={() => history.push("/films")}>
                My Films
              </button>
            </div>
            {userFilm && (
              <div className="navbar-item">
                <span className="film-title">{userFilm?.name}</span>
                {(userFilm?.roleNames || []).map((roleName, index) => (<span className="tag is-light mr-1" key={index}>
                  {roleName}
                </span>))}
              </div>
            )}
          </div>

          <div className="navbar-end mr-1">
            <div className="navbar-item">
              <button type="button" onClick={handleGuideResetClick}>
                <span className="onboarding-step-3">
                  <IconWithBadge count={0} countClass="warning">
                    <LightbulbIcon />
                  </IconWithBadge>
                </span>
              </button>
            </div>
            <div className="navbar-item">
              <button type="button" onClick={handleHelpButtonClick}>
                <span className="onboarding-step-4">
                  <IconWithBadge count={0} countClass="warning">
                    <QuestionMarkIcon />
                  </IconWithBadge>
                </span>
              </button>
            </div>
            {auth.isAdmin() && (
              <AdminMenu mobileMenu={mobileMenu} menuItemClick={menuItemClick} />
            )}

            <UserMessages onDismissAllMessages={onDismissAllMessages}
              allMessages={allMessages}
              onDismissMessage={onDismissMessage}
              onLinkClick={onMessageLinkClick} />

            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-item name">
                <div className="user-circle" style={{ backgroundColor: profileBackgroundColor }}>
                  {userFirstName?.substring(0, 1)}{userLastName?.substring(0, 1)}
                </div>
              </a>

              <div className="navbar-dropdown is-boxed">
                <div className="navbar-item user-details">
                  <div className="user-details-circle"></div>
                  <div>
                    <div>{userName}</div>
                    <div className="user-details-email-address">
                      {userEmailAddress}
                    </div>
                  </div>
                </div>
                <hr className="navbar-divider" />
                <Link
                  to="/account"
                  className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`}
                  onClick={menuItemClick}>
                  Account
                </Link>
                <hr className="navbar-divider" />
                <Link
                  to="/user/settings"
                  className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`}
                  onClick={menuItemClick}>
                  Settings
                </Link>
                <hr className="navbar-divider" />
                <Link
                  to="/user"
                  className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`}
                  onClick={menuItemClick}>
                  User Details
                </Link>
                <hr className="navbar-divider" />
                <Link
                  to="/user/communication-preferences"
                  className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`}
                  onClick={menuItemClick}>
                  Communication Preferences
                </Link>
                <hr className="navbar-divider" />
                <Link
                  to="/change-password"
                  className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`}
                  onClick={menuItemClick}>
                  Change Password
                </Link>
                <hr className="navbar-divider" />
                <a className={`navbar-item ${mobileMenu ? "mobile-menu" : ""}`} onClick={() => onLogout()}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
      {!authenticated && (
        <UnauthenticatedMenu mobileMenu={mobileMenu} />
      )}
    </nav>
  );
};

export default TopMenu;